module.exports = __webpack_public_path__ + "img/cover-recipe-page.e467e10b.png";